import { Tabs } from "@mantine/core";
import { useSearchParams } from "react-router-dom";
import CompanyDetails from "./CompanyDetailsPage";
import Payment from "./PaymentPage";
import CustomTabs from "../ui/CustomTabs/CustomTabs";

const VALID_TABS = new Set(["company", "pay"]);

export default function CompanyPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = VALID_TABS.has(searchParams.get("tab"))
    ? searchParams.get("tab")
    : "company";

  const handleTabChange = (value) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("tab", value);
      return next;
    }, { replace: true });
  };

  const tabOptions = [
    { label: "Company Details", value: "company" },
    { label: "Payment", value: "pay" },
  ];

  return (
    <div>
      <CustomTabs
        tabs={tabOptions}
        value={activeTab}
        onChange={handleTabChange}
        grow={true}
      />

      <Tabs value={activeTab} onChange={handleTabChange} className="mt-4">
        <Tabs.Panel value="company">
          <CompanyDetails />
        </Tabs.Panel>
        <Tabs.Panel value="pay">
          <Payment />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
}
